<template>
  <div class="w-full h-full relative">
    <!-- <DirectionalLight :pz="-100" :py="23" :intensity="0.7"></DirectionalLight>
    <DirectionalLight :pz="100" :py="23" :intensity="0.7"></DirectionalLight>
    <DirectionalLight :px="-100" :py="23" :intensity="0.7"></DirectionalLight>
    <DirectionalLight :px="100" :py="23" :intensity="0.7"></DirectionalLight>
    <GameNPC :char="'david'" :pz="-20">
    </GameNPC>
    <CamControl :py="-13"></CamControl>
    <SwatWalk></SwatWalk> -->


    <!-- <Flame></Flame> -->
    <!-- <O3D :scale="{ x: 1.5, y: 1, z: 1 }" :pz="vs.value * -300">
      <FastFlame v-if="ctx.renderer"></FastFlame>
    </O3D> -->

    <O3D>
      <FastFlame :py="vs.value * screen.height" :opacity="1.0" v-if="ctx.renderer"></FastFlame>
    </O3D>

    <!-- <O3D :py="(1.0 - vs.value) * -screen.height">
      <ParametricRain :scale="{ x: 10, y: 10, z: 10 }"></ParametricRain>
    </O3D> -->

    <Bloomer
      v-if="ctx.renderer"
      :settings="{
        exposure: 1.1,
        bloomStrength: 1.5,
        bloomThreshold: 0.1,
        bloomRadius: 1.3
      }"
    >
    </Bloomer>

    <div class="absolute w-full h-full overflow-scroll scrolling-touch" ref="scroller">
      <div class="w-full h-full flex justify-center items-center">
        <div class="flex justify-center items-center flex-col">
          <div class="px-3 py-1 inline-block text-4xl border-2 text-center border-white text-white">
            O3D-GEN2
          </div>
          <div class="text-white text-center mt-4">
            3D Apps Framework
          </div>
        </div>
        <div class="absolute z-10 w-fullce flex justify-center scroll-cue text-white text-center pb-5">
          <div class="cue-icon" :stlye="{ opacity: 1.0 - vs.value * 3 }">
            <div class="cue-icon-dot"></div>
          </div>
        </div>
      </div>
      <div class="relative w-full h-full flex justify-center items-center">
        <div class="w-full h-full bg-white">
          <MenuBar></MenuBar>
          <div class="padder"></div>
          <div class="flex" :class="{ 'padder-content': true }">
            <DocsLeftMenu v-if="true" class="hidden lg:block"></DocsLeftMenu>
            <div class="w-full bg-white p-5" :class="{ 'right-content': true }">
              <MDArea class="lg:max-w-2xl" :md="require('raw-loader!../HTMLContent/MDs/welcome.md').default">
              </MDArea>
            </div>
          </div>
        </div>
      </div>
    </div>
    <LoadingGUI></LoadingGUI>


    <!-- <Game :nolight="true"></Game> -->
  </div>
</template>

<script>
import { Scene, Color, Object3D, Vector3 } from 'three'
import { PCamera } from '../Reusable/PCamera'
import { getScreen } from '../Reusable/O3DG2'
import { BrowserScroller } from '../Reusable/BrowserScroller'
import { ShaderCubeChrome } from '../Reusable/ShaderCubeChrome'
export default {
  mixins: [
    require('../Reusable/RenderRoot').RenderRoot
  ],
  components: {
  },
  data () {
    return {
      pageCount: 3,
      perPage: 1 / 3,
      chroma: false,
      vs: false,
      screen: false,
      scene: false,
      camera: false
    }
  },
  computed: {
    pageVal () {
      return this.vs.value * this.pageCount
    }
  },
  methods: {
    async setupGraphics () {
      this.scene = new Scene()
      this.camera = new PCamera({ element: this.ctx.element, onResize: this.onResize })
      this.camera.position.z = 180

      this.onResize(() => {
        this.screen = getScreen({ camera: this.camera, depth: this.camera.position.z })
      })
      this.scene.add(this.o3d)

      this.chroma = new ShaderCubeChrome({
        renderer: this.ctx.renderer,
        loop: this.onLoop,
        res: 32,
        color: new Color('#ffffff')
      })

      this.lookAtMe = new Object3D()
      // this.lookAtMe.add(this.ctx.camera)
      // this.lookAtMe.position.y = 0
      // this.lookAtMe.position.z = 30
      let configCam = false

      let TempVec3 = new Vector3()
      let TempVec3Lerp = TempVec3.clone()
      this.onLoop(() => {
        if (this.$refs.npc) {
          if (this.$refs.npc.npc && this.$refs.npc.npc.isReady) {
            if (!configCam) {
              configCam = true
              this.$refs.npc.npc.skeleton.mixamorigHead.add(this.lookAtMe)
              this.lookAtMe.position.y = 0
              this.lookAtMe.position.z = 10
            }

            this.lookAtMe.updateMatrixWorld()
            TempVec3.setFromMatrixPosition(this.lookAtMe.matrixWorld)
            TempVec3Lerp.lerp(TempVec3, 0.1)
            if (this.vs.now > this.perPage) {
              // this.ctx.camera.position.x = TempVec3.x
              // this.ctx.camera.position.y = TempVec3.y
              this.ctx.camera.position.z = TempVec3.z + 15
              this.ctx.camera.lookAt(TempVec3Lerp)
            }
          }
        }
      })

      this.vs = new BrowserScroller({ onLoop: this.onLoop, scroller: this.$refs['scroller'] })
      this.vs.value = 0
      // this.$emit('vm', this)
    }
  },
  mounted () {
    this.setupGraphics()
  }
}
</script>

<style lang="postcss">
.h-banner{
  height: calc(100% - 56px);
}
.h-menu{
  height: 56px;
}
.scroll-cue{
  bottom: 0px;
  left: 0px;
  width: 100%;
}
.cue-icon{
  width: 20px;
  height: 40px;
  border: white solid 1px;
  border-radius: 100px;

  display: inline-flex;
  justify-content: center;
  padding-top: 5px;
  transform: rotateZ(180deg);
  /* background-color: white; */
}
@keyframes run-down {
  0% {
    opacity: 0;
    transform: translateY(0px);
  }
  15% {
    opacity: 1;
    transform: translateY(0px);
  }
  85% {
    opacity: 1;
    transform: translateY(23px);
  }
  100%{
    opacity: 0;
    transform: translateY(23px);
  }
}
.cue-icon-dot{
  @apply bg-white;
  width: 6px;
  height: 6px;
  border-radius: 100px;
  animation: run-down 2s cubic-bezier(0.075, 0.82, 0.165, 1) 0s infinite normal both;
}
.bg-grad{
  background-image: linear-gradient(180deg, rgba(0,0,0,0.0),rgba(0, 195, 255, 0.5));
}
.padder{
  height: 56px;
}
.padder-content{
  height: calc(100% - 56px);
}
@screen lg {
  .right-content{
    width: calc(100% - 285px);
  }
}
</style>